import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=0b407c3c&scoped=true&"
import script from "./imageUpload.vue?vue&type=script&lang=js&"
export * from "./imageUpload.vue?vue&type=script&lang=js&"
import style0 from "./imageUpload.vue?vue&type=style&index=0&id=0b407c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b407c3c",
  null
  
)

export default component.exports